// extracted by mini-css-extract-plugin
export var appStores = "Footer-module--appStores--9087d";
export var container = "Footer-module--container--70893";
export var footer = "Footer-module--footer--2d913";
export var footerBottom = "Footer-module--footerBottom--e48a7";
export var footerCorps = "Footer-module--footerCorps--a41fa";
export var footerCorpsImage = "Footer-module--footerCorpsImage--afe87";
export var footerFineprint = "Footer-module--footerFineprint--549bf";
export var footerSectionContent = "Footer-module--footerSectionContent--4c113";
export var footerSectionTitle = "Footer-module--footerSectionTitle--f2c3a";
export var footerSites = "Footer-module--footerSites--a0d4d";
export var footerSites__title = "Footer-module--footerSites__title--0c57b";
export var langToggle = "Footer-module--langToggle--f6c90";
export var langToggleAlt = "Footer-module--langToggleAlt--f92ec";
export var langToggleCurrent = "Footer-module--langToggleCurrent--7c261";
export var linksContainer = "Footer-module--linksContainer--18d48";
export var social = "Footer-module--social--6e211";
export var socialNetworks = "Footer-module--socialNetworks--49701";
export var tab = "Footer-module--tab--7b2d8";
export var tabContent = "Footer-module--tabContent--bebce";
export var tabLabel = "Footer-module--tabLabel--adb91";
export var tabLabelChevron = "Footer-module--tabLabelChevron--782db";
export var toTop = "Footer-module--toTop--b1844";